import {
  DefaultTriggeredPopupBadge,
  ETriggeredPopupBadgeInternalViewModel
} from '@appcharge/shared-ui';

import { EThemes } from '../enums';

import { BlockMetadata } from './types';

const defaultTriggeredPopupBadge: BlockMetadata = {
  id: ETriggeredPopupBadgeInternalViewModel.DEFAULT,
  version: '1.0.0',
  name: 'Default',
  createdAt: '2025-08-28T08:37:11.255Z',
  isPrivate: false,
  previewAssets: [],
  theme: EThemes.ROYAL_BLAST,
  component: DefaultTriggeredPopupBadge
};

export const triggeredPopupsBadgesDesigns = {
  defaultTriggeredPopupBadge
};

export const triggeredPopupsBadgesDesignsByTheme: Record<
  EThemes,
  BlockMetadata[]
> = Object.values(triggeredPopupsBadgesDesigns).reduce(
  (acc, design) => {
    if (!acc[design.theme]) {
      acc[design.theme] = [];
    }
    acc[design.theme].push(design);
    return acc;
  },
  {} as Record<EThemes, BlockMetadata[]>
);
